module.exports = __webpack_public_path__ + "img/resources_inactive.0230c7a4.svg";